var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactSurveyElement, SurveyQuestionElementBase, } from "./reactquestion_element";
import { ReactQuestionFactory } from "./reactquestion_factory";
import { ReactSurveyElementsWrapper } from "./reactsurveymodel";
import { ReactElementFactory } from "./element-factory";
var SurveyQuestionMatrix = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrix, _super);
    function SurveyQuestionMatrix(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { rowsChanged: 0 };
        return _this;
    }
    Object.defineProperty(SurveyQuestionMatrix.prototype, "question", {
        get: function () {
            return this.questionBase;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrix.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        if (this.question) {
            var self = this;
            this.question.visibleRowsChangedCallback = function () {
                self.setState({ rowsChanged: self.state.rowsChanged + 1 });
            };
        }
    };
    SurveyQuestionMatrix.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        if (this.question) {
            this.question.visibleRowsChangedCallback = null;
        }
    };
    SurveyQuestionMatrix.prototype.renderElement = function () {
        var _this = this;
        var cssClasses = this.question.cssClasses;
        var rowsTH = this.question.hasRows ? React.createElement("td", null) : null;
        var headers = [];
        for (var i = 0; i < this.question.visibleColumns.length; i++) {
            var column = this.question.visibleColumns[i];
            var columText = this.renderLocString(column.locText);
            var style = {};
            if (!!this.question.columnMinWidth) {
                style.minWidth = this.question.columnMinWidth;
                style.width = this.question.columnMinWidth;
            }
            headers.push(React.createElement("th", { className: this.question.cssClasses.headerCell, style: style, key: column.uniqueId }, this.wrapCell({ column: column }, columText, "column-header")));
        }
        var rows = [];
        var visibleRows = this.question.visibleRows;
        for (var i = 0; i < visibleRows.length; i++) {
            var row = visibleRows[i];
            rows.push(React.createElement(SurveyQuestionMatrixRow, { key: row.uniqueId, question: this.question, cssClasses: cssClasses, row: row, isFirst: i == 0 }));
        }
        var header = !this.question.showHeader ? null : (React.createElement("thead", { role: "presentation" },
            React.createElement("tr", null,
                rowsTH,
                headers)));
        return (React.createElement("div", { className: this.question.getTableWrapperCss(), ref: function (root) { return (_this.setControl(root)); } },
            React.createElement("fieldset", { role: "radiogroup" },
                React.createElement("legend", { className: "sv-visuallyhidden" }, this.question.locTitle.renderedHtml),
                React.createElement("table", { className: this.question.getTableCss(), role: "presentation" },
                    header,
                    React.createElement("tbody", null, rows)))));
    };
    return SurveyQuestionMatrix;
}(SurveyQuestionElementBase));
export { SurveyQuestionMatrix };
var SurveyQuestionMatrixRow = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixRow, _super);
    function SurveyQuestionMatrixRow(props) {
        return _super.call(this, props) || this;
    }
    SurveyQuestionMatrixRow.prototype.getStateElement = function () {
        if (!!this.row)
            return this.row.item;
        return _super.prototype.getStateElement.call(this);
    };
    Object.defineProperty(SurveyQuestionMatrixRow.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixRow.prototype, "row", {
        get: function () {
            return this.props.row;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixRow.prototype.wrapCell = function (cell, element, reason) {
        if (!reason) {
            return element;
        }
        var survey = this.question.survey;
        var wrapper = null;
        if (survey) {
            wrapper = ReactSurveyElementsWrapper.wrapMatrixCell(survey, element, cell, reason);
        }
        return wrapper !== null && wrapper !== void 0 ? wrapper : element;
    };
    SurveyQuestionMatrixRow.prototype.canRender = function () {
        return !!this.row;
    };
    SurveyQuestionMatrixRow.prototype.renderElement = function () {
        var rowsTD = null;
        if (this.question.hasRows) {
            var rowText = this.renderLocString(this.row.locText);
            var style = {};
            if (!!this.question.rowTitleWidth) {
                style.minWidth = this.question.rowTitleWidth;
                style.width = this.question.rowTitleWidth;
            }
            rowsTD = React.createElement("td", { style: style, className: this.row.rowTextClasses }, this.wrapCell({ row: this.row }, rowText, "row-header"));
        }
        var tds = this.generateTds();
        return (React.createElement("tr", { className: this.row.rowClasses || undefined },
            rowsTD,
            tds));
    };
    SurveyQuestionMatrixRow.prototype.generateTds = function () {
        var _this = this;
        var tds = [];
        var row = this.row;
        var cellComponent = this.question.cellComponent;
        var _loop_1 = function () {
            var td = null;
            var column = this_1.question.visibleColumns[i];
            var key = column.uniqueId;
            var itemClass = this_1.question.getItemClass(row, column);
            if (this_1.question.hasCellText) {
                var getHandler = function (column) { return function () { return _this.cellClick(row, column); }; };
                td = (React.createElement("td", { key: key, className: itemClass, onClick: getHandler ? getHandler(column) : function () { } }, this_1.renderLocString(this_1.question.getCellDisplayLocText(row.name, column))));
            }
            else {
                var renderedCell = ReactElementFactory.Instance.createElement(cellComponent, {
                    question: this_1.question,
                    row: this_1.row,
                    column: column,
                    columnIndex: i,
                    cssClasses: this_1.cssClasses,
                    cellChanged: function () { _this.cellClick(_this.row, column); }
                });
                td = (React.createElement("td", { key: key, "data-responsive-title": column.locText.renderedHtml, className: this_1.question.cssClasses.cell }, renderedCell));
            }
            tds.push(td);
        };
        var this_1 = this;
        for (var i = 0; i < this.question.visibleColumns.length; i++) {
            _loop_1();
        }
        return tds;
    };
    SurveyQuestionMatrixRow.prototype.cellClick = function (row, column) {
        row.cellClick(column);
        this.setState({ value: row.value });
    };
    return SurveyQuestionMatrixRow;
}(ReactSurveyElement));
export { SurveyQuestionMatrixRow };
var SurveyQuestionMatrixCell = /** @class */ (function (_super) {
    __extends(SurveyQuestionMatrixCell, _super);
    function SurveyQuestionMatrixCell(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnMouseDown = _this.handleOnMouseDown.bind(_this);
        _this.handleOnChange = _this.handleOnChange.bind(_this);
        return _this;
    }
    SurveyQuestionMatrixCell.prototype.handleOnChange = function (event) {
        if (!!this.props.cellChanged) {
            this.props.cellChanged();
        }
        this.setState({ value: this.row.isChecked(this.column) });
    };
    SurveyQuestionMatrixCell.prototype.handleOnMouseDown = function (event) {
        this.question.onMouseDown();
    };
    Object.defineProperty(SurveyQuestionMatrixCell.prototype, "question", {
        get: function () {
            return this.props.question;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixCell.prototype, "row", {
        get: function () {
            return this.props.row;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixCell.prototype, "column", {
        get: function () {
            return this.props.column;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionMatrixCell.prototype, "columnIndex", {
        get: function () {
            return this.props.columnIndex;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionMatrixCell.prototype.canRender = function () {
        return !!this.question && !!this.row;
    };
    SurveyQuestionMatrixCell.prototype.renderElement = function () {
        var isChecked = this.row.isChecked(this.column);
        var inputId = this.question.inputId + "_" + this.row.name + "_" + this.columnIndex;
        var itemClass = this.question.getItemClass(this.row, this.column);
        var itemSvgIcon = this.question.getItemSvgIcon(this.row, this.column);
        var mobileSpan = this.question.isMobile ?
            (React.createElement("span", { className: this.question.cssClasses.cellResponsiveTitle }, this.renderLocString(this.column.locText)))
            : undefined;
        return (React.createElement("label", { onMouseDown: this.handleOnMouseDown, className: itemClass },
            this.renderInput(inputId, isChecked),
            React.createElement("span", { className: this.question.cssMaterialDecorator }, itemSvgIcon ?
                React.createElement("svg", { className: this.question.cssItemDecorator },
                    React.createElement("use", { xlinkHref: itemSvgIcon })) : null),
            mobileSpan));
    };
    SurveyQuestionMatrixCell.prototype.renderInput = function (inputId, isChecked) {
        return (React.createElement("input", { id: inputId, type: this.question.checkType, className: this.question.cssItemValue, name: this.row.fullName, value: this.column.value, disabled: this.row.isDisabledAttr, readOnly: this.row.isReadOnlyAttr, checked: isChecked, onChange: this.handleOnChange, "aria-required": this.question.a11y_input_ariaRequired, "aria-label": this.question.getCellAriaLabel(this.row, this.column), "aria-invalid": this.question.a11y_input_ariaInvalid, "aria-errormessage": this.question.a11y_input_ariaErrormessage }));
    };
    return SurveyQuestionMatrixCell;
}(ReactSurveyElement));
export { SurveyQuestionMatrixCell };
ReactElementFactory.Instance.registerElement("survey-matrix-cell", function (props) {
    return React.createElement(SurveyQuestionMatrixCell, props);
});
ReactQuestionFactory.Instance.registerQuestion("matrix", function (props) {
    return React.createElement(SurveyQuestionMatrix, props);
});
